export default "__VITE_ASSET__CK$JUQ4M__"